// This file is automatically generated. Do not edit manually.

import { AppUserSettings } from "src/api/generated/erp/db/types/tables/appUserSettings";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace UserSettingsApi {
	export async function getAppUserSettings(): Promise<AppUserSettings> {
		const response = await makeAxiosRequest({
			url: "/api/ext/userSettings/getAppUserSettings",
			method: "POST",
			data: {},
		});
		return response as AppUserSettings;
	}

	export async function saveAppUserSettings(args: { settings: AppUserSettings }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/userSettings/saveAppUserSettings",
			method: "POST",
			data: {
				settings: args.settings,
			},
		});
		return response as void;
	}
}
